import type { BaseQLMiddleware } from '@adornis/baseql/metadata/types.js';
import { context } from '@adornis/baseql/server/context.js';
import { NotLoggedInError } from '@adornis/users/db/errors.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';
import { getCurrentUserServer, type ServerCachedUser } from '../util.js';

export const checkAuthorizedMiddleware =
  (isAuthorized: (params: { user: ServerCachedUser; params: Record<string, any> }) => boolean): BaseQLMiddleware =>
  async options => {
    if (context.serverContext) return options.next();
    const user = await getCurrentUserServer();
    if (!user) {
      throw new NotLoggedInError();
    }

    const _isAuthorized = isAuthorized({ user, params: options.args });

    if (!_isAuthorized) {
      throw new ExpectedError('Permission for the call ' + options.field.name + ' is not granted!');
    }
    return options.next();
  };
